import { OverlayTrigger, Popover } from 'react-bootstrap'

const InfoPopover = ({ id, body, ariaLabel = 'More information' }) => (
    <OverlayTrigger
        trigger={['hover', 'focus', 'click']}
        placement="top"
        rootClose
        overlay={
            <Popover id={id}>
                <Popover.Body className="small">{body}</Popover.Body>
            </Popover>
        }
    >
        <button
            type="button"
            className="btn btn-link p-0 ms-1 align-baseline text-muted"
            aria-label={ariaLabel}
            style={{ lineHeight: 1, fontSize: '0.9em' }}
            onClick={(event) => event.stopPropagation()}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                    event.stopPropagation();
                }
            }}
        >
            <i className="fa fa-info-circle" aria-hidden="true" />
            <span className="visually-hidden">{ariaLabel}</span>
        </button>
    </OverlayTrigger>
)

export default InfoPopover
